module.exports = __webpack_public_path__ + "img/int-coloured-white-txt.6fab507b.svg";